var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiCityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F61639BF-C0CD-47FE-8788-9AB49414CB68") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MODIFIED-MULTI-CITY-DETAILS",
    transform: "translate(-1039.000000, -723.000000)",
    fill: "#FFCC00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(0.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1039.000000, 186.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8571429,0 C15.2232143,0 17.1428571,1.91964286 17.1428571,4.28571429 L17.1427509,5.52887844 C17.1820228,5.52552219 17.2217638,5.52380952 17.2619048,5.52380952 L22.857,5.523 L22.8571429,4.28571429 C22.8571429,1.91964286 24.7767857,0 27.1428571,0 L35.7142857,0 C38.0803571,0 40,1.91964286 40,4.28571429 L40,12.8571429 C40,15.2232143 38.0803571,17.1428571 35.7142857,17.1428571 L27.1428571,17.1428571 C24.7767857,17.1428571 22.8571429,15.2232143 22.8571429,12.8571429 L22.857,9.666 L17.2619048,9.66666667 L17.142,9.661 L17.1428571,12.8571429 C17.1428571,15.2232143 15.2232143,17.1428571 12.8571429,17.1428571 L10.3520739,17.1427509 C10.3554302,17.1820228 10.3571429,17.2217638 10.3571429,17.2619048 L10.357,22.857 L12.8571429,22.8571429 C15.2232143,22.8571429 17.1428571,24.7767857 17.1428571,27.1428571 L17.1428571,35.7142857 C17.1428571,38.0803571 15.2232143,40 12.8571429,40 L4.28571429,40 C1.91964286,40 0,38.0803571 0,35.7142857 L0,27.1428571 C0,24.7767857 1.91964286,22.8571429 4.28571429,22.8571429 L6.214,22.857 L6.21428571,17.2619048 L6.219,17.142 L4.28571429,17.1428571 C1.91964286,17.1428571 0,15.2232143 0,12.8571429 L0,4.28571429 C0,1.91964286 1.91964286,0 4.28571429,0 L12.8571429,0 Z M12.8571429,27.1428571 L4.28571429,27.1428571 L4.28571429,35.7142857 L12.8571429,35.7142857 L12.8571429,27.1428571 Z M12.8571429,4.28571429 L4.28571429,4.28571429 L4.28571429,12.8571429 L12.8571429,12.8571429 L12.8571429,4.28571429 Z M35.7142857,4.28571429 L27.1428571,4.28571429 L27.1428571,12.8571429 L35.7142857,12.8571429 L35.7142857,4.28571429 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiCityIcon);
export default __webpack_public_path__ + "static/media/multi-city-icon.7a307082d9b60dad825477a5417c9760.svg";
export { ForwardRef as ReactComponent };